export default __webpack_public_path__ + "static/media/mucha2.4c84170e.ogg";